var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eaf9ff;}.cls-2{fill:#3dabdd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54,0H28A28,28,0,0,0,0,28V54A28,28,0,0,0,28,82H54A28,28,0,0,0,82,54V28A28,28,0,0,0,54,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lunch_product",
    "data-name": "Lunch product"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.92,33.84a.66.66,0,0,0-.44-.45L46.82,28.72a.68.68,0,0,0-.71.2L42,33.68l-4.17-4.76a.66.66,0,0,0-.7-.2L22.41,33.39a.67.67,0,0,0-.43.84.76.76,0,0,0,.13.23l4.28,4.9-4.28,4.89a.67.67,0,0,0,.06.94.72.72,0,0,0,.24.14l4.2,1.33v10.7a.66.66,0,0,0,.44.62l14.67,5.34h0a.64.64,0,0,0,.43,0h0l7-2.54,0,.09a.67.67,0,0,0,1.12.33l.94-1,2.91,2.91a.66.66,0,0,0,.94,0L57,61.28a.68.68,0,0,0,0-1l-1.76-1.76L56.84,58a.65.65,0,0,0,.44-.62V46.66l4.2-1.33a.67.67,0,0,0,.43-.84.56.56,0,0,0-.13-.24L57.5,39.36l4.28-4.9A.66.66,0,0,0,61.92,33.84ZM42,43.32l-12.47-4,11.8-3.76v3.09a.67.67,0,0,0,.67.67.66.66,0,0,0,.66-.67V35.6l11.8,3.76Zm-4.88-13.2,3.7,4.24L27.49,38.59l-3.7-4.24Zm-9.58,10,13.28,4.23-3.7,4.24L23.79,44.36ZM54.61,61.75,51.7,58.84a.66.66,0,0,0-.94,0l-.56.56-.9-3.92,3.91.91-.56.56a.68.68,0,0,0,0,.95l2.91,2.9ZM56,56.89l-1.78.64-.11-.11.94-.94a.66.66,0,0,0,0-.94.64.64,0,0,0-.32-.18l-6.12-1.42a.67.67,0,0,0-.8.5.76.76,0,0,0,0,.3l1.09,4.73-6.24,2.27V56.69A.66.66,0,0,0,42,56a.67.67,0,0,0-.67.67v5.05L28,56.89v-9.8L37.08,50a.68.68,0,0,0,.2,0,.67.67,0,0,0,.5-.22l3.5-4v5.56A.67.67,0,0,0,42,52a.66.66,0,0,0,.66-.66V45.8l3.5,4a.68.68,0,0,0,.5.22.64.64,0,0,0,.2,0L56,47.09Zm-9.12-8.3-3.71-4.24L56.4,40.12l3.71,4.24Zm9.57-10L43.12,34.36l3.71-4.24,13.28,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.61,26.69a.65.65,0,0,0,.56-.3l.34-.51a2.69,2.69,0,0,1,2.22-1.19h.88a.67.67,0,1,0,0-1.33h-.88a4,4,0,0,0-3.33,1.78l-.34.51a.67.67,0,0,0,.18.93A.7.7,0,0,0,44.61,26.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.81,24.68l1.19.24a2,2,0,0,1,1.61,2v.48a.67.67,0,0,0,1.34,0v-.48a3.35,3.35,0,0,0-2.68-3.27l-1.19-.24a.67.67,0,0,0-.27,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.74,28.2a2,2,0,0,1,1.6-.89h0l-.12.33a2,2,0,0,0,1.14,2.59l.21.07a2.41,2.41,0,0,0,.53.07,2,2,0,0,0,.53-4l-.15,0-.34-.07a2.65,2.65,0,0,1,2-1.52.67.67,0,0,0,.57-.76.67.67,0,0,0-.76-.56A4,4,0,0,0,55.8,26l-.23,0a.38.38,0,0,0-.15,0h-.13a3.36,3.36,0,0,0-2.66,1.48.67.67,0,0,0,.21.92.66.66,0,0,0,.9-.18Zm2.73-.09.2-.56.56.11a.61.61,0,0,1,.44.3.66.66,0,0,1,.07.58.63.63,0,0,1-.31.4.66.66,0,0,1-.93-.27.69.69,0,0,1,0-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.71,24.76a2.67,2.67,0,0,1,2.05,1.52l-.35.07a2,2,0,0,0,.39,4,2.32,2.32,0,0,0,.52-.07,2,2,0,0,0,1.42-2.45l-.06-.19-.13-.35h0a2,2,0,0,1,1.59.89.67.67,0,0,0,1.13-.71l0,0A3.31,3.31,0,0,0,26.6,26h-.13l-.14,0-.24,0a4,4,0,0,0-3.19-2.59.66.66,0,0,0-.75.56.67.67,0,0,0,.56.76Zm2.72,3.36a.67.67,0,0,1-1,.82.68.68,0,0,1-.33-.46.67.67,0,0,1,.47-.81h.05l.56-.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.95,
    cy: 54.02,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.95,
    cy: 41.36,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 43.28,
    cy: 28.02,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.61,
    cy: 24.02,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 61.28,
    cy: 24.02,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 33.95,
    cy: 24.02,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 29.95,
    cy: 29.36,
    r: 0.67
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.ef68b2cfc16a8f7eb496a4ae3b593ae3.svg";
export { ForwardRef as ReactComponent };